import {
  CashbackWizardContext,
  NaturalPersonsEnum,
} from "@features/cashbackWizard2.0/types";
import { isExistingUser } from "@features/cashbackWizard2.0/utils/guards";

export type PlaceholderKeyMapper = "placeholder" | "companyplaceholder";

const isJoined = (ctx: CashbackWizardContext) =>
  ctx.currentNaturalPerson === NaturalPersonsEnum.naturalPerson2;

const isMinor = (ctx: CashbackWizardContext) =>
  ctx.accountHolderType === "minor";

const isLegalGuardian1 = (ctx: CashbackWizardContext) =>
  ctx.currentNaturalPerson === NaturalPersonsEnum.naturalPerson2;

const isLegalGuardian2 = (ctx: CashbackWizardContext) =>
  ctx.currentNaturalPerson === NaturalPersonsEnum.naturalPerson3;

const isCompany = (ctx: CashbackWizardContext) => ctx.accountType === "COMPANY";

export const titleKeyFactory = (
  ctx: CashbackWizardContext,
  isOnvista?: boolean
): string[] => {
  const headings = [];

  if (isExistingUser(ctx)) {
    headings.push("existingUser");
  }

  if (isCompany(ctx)) {
    headings.push("company");
  }

  if (isMinor(ctx)) {
    if (isLegalGuardian1(ctx)) {
      headings.push("legalGuardian1");
    } else if (isLegalGuardian2(ctx)) {
      headings.push("legalGuardian2");
    } else {
      headings.push("minor");
    }
  } else if (isJoined(ctx)) {
    headings.push("partner");
  }

  if (isOnvista) {
    headings.push("onvista");
  }

  if (!headings.length) headings.push("default");

  return headings;
};

export const placeholderKeyFactory = (
  ctx: CashbackWizardContext
): PlaceholderKeyMapper => {
  if (isCompany(ctx)) return "companyplaceholder";
  return "placeholder";
};
